export default __webpack_public_path__ + "static/media/english-to-japanese-screenshot-04.036f1743.png";